module.exports = __webpack_public_path__ + "static/media/user.a1b3238c.jpg";